export default __webpack_public_path__ + "static/media/lightningcast.634b10e2.png";